import { WabunkaExperience } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience';

// wabunka-backend `WabunkaExperienceRecommendationListResponse` のレスポンス型。
// wabunka-protos npm パッケージへ新しい proto が反映されたら
// `@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_recommendation` からの import に置き換える。
export interface RecommendationListResponse {
  experiences: WabunkaExperience[];
}

/**
 * バックエンドの recommendation エンドポイントレスポンスを変換する。
 * - null / 非オブジェクトは空結果にフォールバックする
 * - WabunkaExperience.fromJSON を経由して proto enum 文字列→整数の正規化を行う
 */
export const fromRecommendationListJson = (json: unknown): RecommendationListResponse => {
  const raw = json != null && typeof json === 'object' ? (json as { experiences?: unknown }).experiences : undefined;
  const experiences = Array.isArray(raw) ? raw.map((e) => WabunkaExperience.fromJSON(e)) : [];
  return { experiences };
};
